var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"breadcrumb"},[_c('router-link',{attrs:{"to":"/"}},[_c('span',[_vm._v("Home ")])]),(_vm.noslug)?_c('span',[_vm._v("/")]):_vm._e(),_c('router-link',{attrs:{"to":_vm.path}},[_c('span',[_vm._v(" "+_vm._s(_vm.breadcrumblink))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }